<template>
    <b-card no-body>

        <b-modal id="update" :title="['Güncelle',bank.Name || null].join(' - ')" body-class="p-0"  no-close-on-esc no-close-on-backdrop>
            <bank-integration-update-value v-model="parameters"></bank-integration-update-value>
            <template #modal-footer><v-executer :action="update" text="Güncelle" :loading="loading"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    search
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { BankApi } from '@/api/bank'
import BankIntegrationUpdateValue from './components/BankIntegrationUpdateValue.vue'
export default {
    components:{
        BCard,
        BankIntegrationUpdateValue
    },
    data(){
        return{
            fields:[
                {name:'Banka',key:'Name',thClass:'w-100',sortable:true}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit }
            ],
            bank:{
                Value:null,
                Name:null
            },
            loading:false,
            parameters:[]
        }
    },
    methods:{
        clearForm(){
            this.bank.Value = null
            this.bank.Name = null
            this.parameters = []
        },
        provider(){
            return BankApi.List()
        },
        edit(item){
            this.$refs.table.rowLoading(true)
            this.clearForm()
            this.bank.Value = item.Value
            this.bank.Name = item.Name
            BankApi.BankParameterList(item.Value).then(res=>{
                this.$refs.table.rowLoading(false)
                if(res.data.Success){
                    this.parameters = res.data.Data
                    this.$showModal('update')
                }else this.$result(res)
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
                this.$result(null,res)
            })
        },
        update(){
            this.loading = true
            const values = this.parameters?.map(p=>{ return { Id:p.Id,Value:p.Value,Key:p.Key,Bank:p.Bank } }) || []
            BankApi.BankParameterUpdate(values).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('update')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        }
    }
}
</script>

<style>

</style>